import { makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import ProductDiscountPercentElement from '../../../components/ProductDiscountPercentElement';

export interface ProductDetailDiscountsProps extends StandardDivProps<ProductDetailDiscountsClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailDiscountsClassKey = 'root';

const themeSettings = { name: 'ProductDetailDiscounts' };
const useStyles = makeStyles(
  (/* theme */) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
    },
  }),
  themeSettings,
);

const ProductDetailDiscounts = React.forwardRef<HTMLDivElement, ProductDetailDiscountsProps>(
  ({ className, classes: pClasses, product, ...rest }, ref) => {
    const classes = useStyles({ classes: pClasses });
    // const currency = useRecoilValue(currencyState);
    const isDiscount = product.discountAbsolute !== null;

    return (
      <div ref={ref} className={clsx(classes.root, className)} {...rest}>
        {isDiscount && (
          <>
            {/* <AbsoluteDiscount value={product.discountAbsolute} currency={currency} /> */}
            <PercentDiscount value={product.discountPercent} />
          </>
        )}
      </div>
    );
  },
);

ProductDetailDiscounts.displayName = 'ProductDetailDiscounts';

export default withThemeProps(themeSettings)(ProductDetailDiscounts);

const elementStyles = (absolute?: boolean) => (theme: Theme) => ({
  root: {
    ...theme.typography.subtitle1,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
    ...(absolute ? { textDecoration: 'line-through' } : {}),
  },
});

const PercentDiscount = withStyles(elementStyles(false))(
  ProductDiscountPercentElement,
) as typeof ProductDiscountPercentElement;

// const AbsoluteDiscount = withStyles(elementStyles(true))(ProductDiscountAbsoluteElement);
